<span
  class="ui-radio-mark"
  role="radio"
  [attr.aria-checked]="isChecked()"
  [attr.aria-disabled]="isDisabled() || null"
  [attr.id]="inputId() || null"
  [attr.data-name]="name() || null"
>
  <span class="ui-radio-dot" aria-hidden="true"></span>
</span>

@if (label()) {
  <span class="ui-radio-label">{{ label() }}</span>
}
